import { render } from "./VaIconMenuCollapsed.vue?vue&type=template&id=e711c6e0"
import script from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"
export * from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"

import "./VaIconMenuCollapsed.vue?vue&type=style&index=0&id=e711c6e0&lang=scss"
script.render = render

export default script